import React, { Component } from "react";
import {
    Card,
    CardBody
} from "reactstrap";

import Helpers from "../../Utils/Helpers";
import Registry from "../../Utils/Registry";


class AnalyticsEcoPeriodCard extends Component{
    constructor(props){
        super(props);

        this.loadData = this.loadData.bind(this);

        this.api = Registry.registered("api");

        this.state = {
            loading: false,
            period: this.props.period,
            value: ""
        };
    }

    componentDidMount(){
        this.loadData();
    }

    loadData(){
        this.setState({ loading: true });

        this.api.get("/stats/customers?is_business=1&period=" + this.state.period)
            .then(results => {
                let key = this.props.type + "_eco";
                let total = 0;
                let nb = 0;
                let k = 0;

                for(let data of results.data){
                    let _k = data.day+data.week+data.month+data.year;
                    if(data.hasOwnProperty(key)){
                        if(data[key]){
                            total += data[key];
                            if(_k !== k)
                                nb++;
                            k = _k;
                        }
                    }
                }

                let value = 0;
                if(nb)
                    value = total / nb;

                if(this.props.type === "time")
                    value = Helpers.format_time_eco(value);
                else if(this.props.type === "co2")
                    value = Helpers.format_co2_eco(value, true);
                else
                    value = Helpers.formatNumeralInt(value);

                this.setState({
                    loading: false,
                    value: value
                });
            });
    }

    setPeriod(p){
        this.setState({period: p}, () => {
            this.loadData();
        });
    }

    render(){
        let title = "";
        switch(this.props.type){
            case "time":
                title = "Temps";
                break;
            case "co2":
                title = "CO2";
                break;
            case "euro":
                title = "Euros";
                break;
        }

        return (
            <Card>
                <CardBody className="card-body">
                    <div className={this.props.analytics ? "eco-card-body" : "pull-left"}>
                        <div className="blue_dark f-16">
                            { title }
                            {
                                this.props.type === "time" ?
                                    <i className={"icon icon-help pad-5 tooltip-info" + (this.props.analytics ? '' : '-home')} aria-hidden="true">
                                        <span className="tooltip-info-text">
                                            Calculé lors de chaque livraison. Correspond au temps de non déplacement
                                            moyen (10 min aller / 10 min retour) vers la station-service pour chaque véhicule livré.
                                        </span>
                                    </i> : ""
                            }
                            {
                                this.props.type === "co2" ?
                                    <i className={"icon icon-help pad-5 tooltip-info-co2" + (this.props.analytics ? '' : '-home')} aria-hidden="true">
                                        <span className="tooltip-info-co2-text">
                                            Calculé lors de chaque livraison. Correspond à la <span className="bold">distance de non déplacement moyen </span>
                                            (1,5 km aller / 1,5 km retour) vers la station-service multipliée par le <span className="bold">volume d'émission
                                            moyen</span> de chaque véhicule thermique livré.
                                        </span>
                                    </i>  : ""
                            }
                            {
                                this.props.type === "euro" ?
                                    <i className={"icon icon-help pad-5 tooltip-info" + (this.props.analytics ? '' : '-home')} aria-hidden="true">
                                        <span className="tooltip-info-text">
                                            Calculé lors de chaque livraison. Correspond au <span className="bold">temps de non déplacement moyen </span>
                                            (10 min aller / 10 min retour) vers la station-service multiplié par le <span className="bold">SMIC horaire </span>
                                            pendant ces 20 minutes pour chaque véhicule livré.
                                        </span>
                                    </i> : ""
                            }
                        </div>
                        <div className="ty-period-filters">
                            <span
                                className={(this.state.period === "week" ? "blue" : "") + " pointer"}
                                onClick={() => { this.setPeriod("week"); }}
                            >Semaine</span> |
                            <span
                                className={(this.state.period === "month" ? "blue" : "") + " pointer"}
                                onClick={() => { this.setPeriod("month"); }}
                            > Mois</span>
                        </div>
                    </div>
                    <div className={this.props.analytics ? "eco-card-value-analytics" : "eco-card-value"}>
                        {
                            this.state.loading ?
                                <i className="icon icon-loading animated spin infinite bold f-20"> </i>
                                :
                                <span>{ this.state.value + (this.props.type === "euro" ? " €" : "") }</span>
                        }
                    </div>
                </CardBody>
            </Card>
        );
    }
}

AnalyticsEcoPeriodCard.defaultProps = {
    type: "time",
    period: "week",
    unit: "",
    analytics: false
};

export default AnalyticsEcoPeriodCard;



// WEBPACK FOOTER //
// ./src/components/Analytics/EcoPeriodCard.js